var map = {
	"./assistant-active.png": 2693,
	"./bbs-active.png": 4427,
	"./blibli-active.png": 4178,
	"./btn-active.png": 6053,
	"./cancel-active.png": 3114,
	"./edit-active.png": 6037,
	"./home-active.png": 6593,
	"./prize-active.png": 7505,
	"./qq-active.png": 7012,
	"./service-active.png": 9650,
	"./submit-active.png": 6266,
	"./tieba-active.png": 5452,
	"./weixin-active.png": 4552,
	"./wenjuan-active.png": 5865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9337;